import ServerRequestUtil from '../utils/ServerRequestUtil';
import AuthUtil from '../utils/AuthUtil';
import JSCookie from 'js-cookie';

export default new class {

    constructor() {
    }

    getLocalStorage() {
        let obj = new Object()
        obj.selection = localStorage.getItem('selection')
        obj.subject = localStorage.getItem('subject')
        obj.content = localStorage.getItem('content')
        return obj
    }

    async confirm(registrationData) {
      return ServerRequestUtil.post('/api/app/contact/confirm', {...registrationData});
    }

    async sendMail(registrationData) {
      return ServerRequestUtil.post('/api/app/contact/send', {...registrationData});
    }
}
